/* istanbul ignore file */
/* require unit tests for testing */

import utils from '@lib/utils'

declare global {
  type CartItem = {
    item: string
    price: number
    quantity: number
    currency: Currency
  }
}

type SetEmailCmd = ['setEmail', string]
type TagCmd = ['tag', string, Record<string, unknown>]
type CartCmd = ['cart', CartItem[]]
type PurchaseCmd = ['purchase', string, CartItem[], number]
type GoCmd = ['go']

type Cmd = SetEmailCmd | TagCmd | CartCmd | PurchaseCmd | GoCmd

class EmarsysCommand {
  constructor(private cmd: Cmd) {}

  get command(): Cmd {
    return this.cmd
  }

  emit() {
    window.ScarabQueue = window.ScarabQueue || []
    window.ScarabQueue.push(this.cmd)
  }
}

const goCommand = new EmarsysCommand(['go'])

class EmarsysEventsService {
  private queue: EmarsysCommand[] = []

  private emitAll() {
    const commands = this.queue.splice(0) // get queued commands and clear

    commands.push(goCommand)

    commands.forEach(command => command.emit()) // emit everything
  }

  private emitAllDebounced: () => void = utils.function.debounce(() => this.emitAll(), 1000)

  push(...cmd: Cmd) {
    const isDuplicate = this.queue.some(emarsysCommand => utils.object.isEqual(emarsysCommand.command, cmd))

    if (isDuplicate) return

    this.queue.push(new EmarsysCommand(cmd))
    this.emitAllDebounced()
  }
}

export default new EmarsysEventsService() // export as a singleton so all components work with the same instance
